import React from 'react';
import styles from './FeatureCard.module.css';

const FeatureCard = ({
    id,
    title,
    subtitle,
    type,
    status,
    image,
    coordinates,
    area,
    attributes = {},
    actions = [],
    selected = false,
    onSelect,
    onEdit,
    onDelete,
    onView,
    className = ''
}) => {
    const getStatusColor = (status) => {
        switch (status) {
            case 'active':
            case 'is_building':
                return 'var(--color-success)';
            case 'planned':
            case 'is_planned':
                return 'var(--color-warning)';
            case 'inactive':
            case 'archived':
                return 'var(--color-text-secondary)';
            default:
                return 'var(--color-primary)';
        }
    };

    const getTypeIcon = (type) => {
        switch (type) {
            case 'plot':
                return '▢';
            case 'building':
                return '▣';
            case 'road':
                return '▨';
            case 'marker':
                return '▲';
            default:
                return '•';
        }
    };

    return (
        <article
            className={`${styles.card} ${selected ? styles.selected : ''} ${className}`}
            role="article"
            style={{ minWidth: 0 }} // Ensures the card can shrink within grid/flex containers
            aria-selected={selected}
        >
            {/* Заголовок с типом и статусом */}
            <header className={styles.header}>
                <div className={styles.typeBadge}>
                    <span className={styles.typeIcon}>{getTypeIcon(type)}</span>
                    <span className={styles.typeLabel}>{type}</span>
                </div>
                {status && (
                    <div
                        className={styles.statusBadge}
                        style={{ backgroundColor: getStatusColor(status) }}
                        title={status}
                    >
                        {status}
                    </div>
                )}
            </header>

            {/* Изображение */}
            {image && (
                <div className={styles.imageContainer}>
                    <img src={image} alt={title} className={styles.image} />
                </div>
            )}

            {/* Контент */}
            <div className={styles.content}>
                <h3 className={styles.title}>{title}</h3>
                {subtitle && <p className={styles.subtitle}>{subtitle}</p>}

                {/* Атрибуты */}
                <div className={styles.attributes}>
                    {area && (
                        <div className={styles.attribute}>
                            <span className={styles.attributeLabel}>Площадь:</span>
                            <span className={styles.attributeValue}>{area} м²</span>
                        </div>
                    )}
                    {coordinates && (
                        <div className={styles.attribute}>
                            <span className={styles.attributeLabel}>Координаты:</span>
                            <span className={styles.attributeValue}>
                                {coordinates.lat.toFixed(4)}, {coordinates.lng.toFixed(4)}
                            </span>
                        </div>
                    )}
                    {Object.entries(attributes)
                        .filter(([_, value]) => value != null && value !== '')
                        .map(([key, value]) => (
                            <div key={key} className={styles.attribute}>
                                <span className={styles.attributeLabel}>{key}:</span>
                                <span className={styles.attributeValue}>{value}</span>
                            </div>
                        ))}
                </div>
            </div>

            {/* Действия */}
            {actions.length > 0 && (
                <footer className={styles.footer}>
                    {actions.map((action, index) => (
                        <button
                            key={index}
                            className={`${styles.actionButton} ${styles[action.variant]}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (action.onClick) {
                                    action.onClick();
                                }
                            }}
                            disabled={action.disabled}
                            title={action.title}
                        >
                            {action.icon && <span className={styles.actionIcon}>{action.icon}</span>}
                            <span className={styles.actionLabel}>{action.label}</span>
                        </button>
                    ))}
                </footer>
            )}
        </article>
    );
};

export default FeatureCard;
